var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 341,
    height: 341,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2392,
    y: 204,
    width: 341,
    height: 341
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.101552,
    y: -0.20933,
    width: 2078916,
    height: 2085013
  })), /*#__PURE__*/React.createElement("image", {
    width: 74,
    height: 74,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAABKCAMAAAArDjJDAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABjUExURQAAAJeXl5OTk5SUlJWVlZSUlJSUlJOTk5WVlZOTk5SUlJSUlJSUlJWVlZWVlZWVlZSUlJOTk5WVlZWVlZ+fn5WVlY+Pj5KSkpSUlJOTk5SUlJSUlJSUlJWVlZSUlJWVlZOTk5juGjcAAAAhdFJOUwAgQHCHv494MIDP/9dIl9/nUGDHCK8QOO9o96dYGLefKL0UMzMAAAAJcEhZcwAAFxEAABcRAcom8z8AAAPXSURBVFhHnZjbtqIwDEALiAiicBAV8Pr/XzlJG4EmKejsh1k9hcY0d8YsEsXJJiW2WRzR9s/s8mLPKDc7evgDh2NFxxn18Y9e+Y6mpoMqdUKvrXMQF+NU32m2S+n9RU4xvR6mPdK7q5wvdCRAtHq3iWrRm9eOXvuKbsFi/UAvfUtOBwVfm2ni1tJZn/+QBManwx49PfyRDR2fEf9qpw93EjASBXyXTcYIqD2wmGgD8dTRc0vg16oHPXfcaFuQ0QtAYzeqe8JNcaIXLDva1IHoyWm530NVOHBZ81A90Z6OJ+oGr3NZxWTQP9oK4InaN3CAyxoLWMjmSJduEyjpUXYraUeTVX/USmhD8mxmidEeznbTJh6TRWq1oep7Fh0GyyKlsC9rcMUrYKnS1clHnx/T9Jj3LnriHv7Z4R39u+COMS/6y+eFj9p+5tsioboJCsHJN207nvaJej+bpbzxuFbzwKvl8dPtEQMaNaY/PNAgD8WxBZpvFhkTmNUbWs/BONyp2nZoQc0kaJAxXiZK0PY6eaiOZgoOBzCh0t+6llnPMmBMznQCu83u1MFTLWdjLRS2LAH8xLE6b2k9IzEZrSYGiCAvaJgo/Psha9dRMSEoZf09wkXhb0lnpUZaEAqsrz8XhT92peVEZUTw1OBVPw6EKHxFjF+d3IIAYQ4SosBbyg2lKEgvdlCKgvCQnpcZCL/IXCFFQfJKY0mt3oa7QooqIIZpOSHzBioJEy9FYXuk5cgggwFimYmC5GajyaCIqmQzhRRjvWzIehbcFUQxLUdO0qlXY1w7WCBVMvpm7rQagVa7OmkdlWDIpHSYElZarC2ZogyACjywYJho/SYnwFbF3YXFXdwG7O63AAFE6IWWI9hyDrQegU4nQ9kDEsJNSDOwEYrb4Fyy6EMcZUVBsR1XRBZ0u2jBWjgxCsdAeABCV5xLFpwIBpBjhps/LkIDbM1ae7RACeUpCZrSPCrbB7ZapakgEJ2KyigfkeraAbrR7IWDzFu0m49S2qxWQdUyV1E1TpCgJhIlblQK1JIPO+jncBPP56WdhGPZAsf5EdD85XzyTlJ7tEszVFT/0KPx0SEiDijc2OcRa2P5XCm4v9QaeDJhsZoEAxpwhjqwwb1ed3cvE91fwtEO8ekVnrj3Q+rspTN5b+S/PlI/86xPu/yhE6BU/7fhorlxhRLHXIU2+FUYIlV1sizYXkOx+MTfgqs4g/sYCfJWZm+dmkWmQhKIRJ8u97IlwCVfveWwDdvb5xGooB9eY6X7gigJBlmRBWIpzKNXenTa/yzHcWny85hOxTNvFixkzD/pWLftng1a+wAAAABJRU5ErkJggg==",
    preserveAspectRatio: "none",
    id: "img2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.257812-0.036605 2078916-0.036605 2078916 2078916-0.25 2078916Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-2392 -204)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    transform: "matrix(0.000164028 0 0 0.000164028 2392 204)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img2",
    transform: "matrix(28093.5 0 0 28093.5 -0.257812 -0.036605)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.7d49dc69ed678bb477c98fb49eaf1ca8.svg";
export { ForwardRef as ReactComponent };